export const transmissionCountAction = {
  changeCount: (state, action) => {
    const { view, count } = action.payload;

    state.transmissionCount[view] = count;
  },
};
